import Swal from "sweetalert2";

export function showSucess(title: string, text: string, html?: string) {
  Swal.fire({
    text: text,
    title: title,
    html: html,
    icon: "success",
    showConfirmButton: true,
    showCloseButton: true,
    confirmButtonColor: "#00A676",
  });
}

export function showError(title: string, text: string, html?: string) {
  Swal.fire({
    title: title,
    text: text,
    html: html,
    showConfirmButton: true,
    showCloseButton: true,
    icon: "error",
  });
}

export function showNotification(title: string, text: string, html?: string) {
  Swal.fire({
    text: text,
    title: title,
    html: html,
    iconHtml:
      '<i style="font-size: 4rem; color: `#075A7B` " class="far fa-question-circle"></i>',
    showConfirmButton: true,
    showCloseButton: true,
  });
}

export function showWarning(title: string, text: string, html?: string) {
  Swal.fire({
    text: text,
    title: title,
    html: html,
    icon: "warning",
    showConfirmButton: true,
    showCloseButton: true,
  });
}
